// The Menus field (owner, 2026-10-07): a coupon may name the menus it
// applies to; nothing named means every menu.
export const MENU_FIELD_COPY = {
  label: 'Menus',
  column: 'Menus',
  placeholder: 'Any menu',
  noMenusCompany: 'No menus yet',
  noMenusStore: 'No menus on this store',
  hint: 'Leave empty to accept every menu.',
  any: 'Any',
  notSaved:
    'This server did not save the menus. Update the API before restricting coupons to menus.',
};
